import { CircularProgress, IconButton } from '@material-ui/core';
import styled from 'styled-components';
import PrimitiveModal from '../../../../newComponents/Modal';

export const CustomModal = styled(PrimitiveModal)`
  gap: 10px;
  position: relative;
  padding: 28px 32px;
  border-radius: 8px;
  max-width: 400px;
  font-family: 'Sora', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-height: 90vh;

  p {
    text-align: center;
    font-family: 'Sora', sans-serif;
    font-size: 14px;
    color: #7c8db5;
    margin-bottom: 10px;

    strong {
      color: #101d40;
      font-weight: 600;
      margin-top: 5px;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    color: var(--color-navy-blue);
    font-size: 20px;
    text-align: center;
    font-weight: 800;
    margin-top: 15px;
    font-family: 'Sora', sans-serif;
  }

  button {
    font-family: Sora, sans-serif;
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(215, 222, 233, 0.25);
    svg {
      color: #4f4f4f;
      font-size: 22px;
    }
    &:hover {
      background-color: rgba(215, 222, 233, 0.5);
    }
  }
`;

export const ModalBody = styled.div`
  width: 400px;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: black transparent;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    padding: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #a1a1a1;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 250px;
  }

  h2 {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: var(--color-alba-grandeza);
    font-family: Sora, sans-serif;
  }

  h3 {
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    color: var(--color-navy-blue);
    font-family: Sora, sans-serif;

    span {
      color: var(--color-alba-grandeza);
      font-weight: 400;
      font-size: 14px;
    }
  }

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: var(--color-alba-grandeza);
    font-family: Sora, sans-serif;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  user-select: none;
`;
